import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { LOAD_JOB } from '../actions';

const loadJobEpic = (action$, store, { api }) =>
    action$.ofType(LOAD_JOB).mergeMap(action =>
        Observable.combineLatest(
            Observable.from(api.fetchJob(action.payload)),
            Observable.from(api.fetchJobApplications(action.payload)),
            Observable.from(api.fetchJobInvites(action.payload)),
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            (job, applications, invites) =>
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                toAction(job, applications, invites),
        ).catch(error => {
            // TODO Better approach use permissions
            if (error.response.status === 403) {
                return Observable.from(api.fetchJob(action.payload)).map(
                    response =>
                        // eslint-disable-next-line @typescript-eslint/no-use-before-define
                        toAction(response),
                );
            }
            return Observable.of(
                actions.loadJobFailure(
                    'Problem loading jobs, invitations and invites',
                ),
            );
        }),
    );

const toAction = (job, applications, invites) => {
    try {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        return actions.loadJobSuccess(
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            getMergedContent(job, applications, invites),
        );
    } catch (e) {
        return actions.loadJobFailure('Problem loading job details');
    }
};

const getContent = payload => {
    if (payload) {
        return payload.data ? payload.data.content : undefined;
    }
    return undefined;
};

const getMergedContent = (job, applications, invites) => ({
    content: {
        job: getContent(job),
        applications: getContent(applications),
        invites: getContent(invites),
    },
    meta: job ? job.meta : undefined,
});

export default loadJobEpic;
